import {Injectable} from '@angular/core';
import {onValue, ref, set} from 'firebase/database';
import {firebaseDb} from 'app/blocks/service/firebase-app';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Principal} from 'app/core/auth/principal.service';
import {UnsubscribeDirective} from 'app/common/unsubscribe.directive';
import {environment} from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ServerEventService extends UnsubscribeDirective {
    public userNotificationEvent = new BehaviorSubject<any>([]);
    public tenantSettingUpdateEvent = new BehaviorSubject<any>([]);
    public exhangeRateUpdateEvent = new BehaviorSubject<any>([]);
    public runStatusChangeEvent = new BehaviorSubject<any>([]);
    public reindexEvent = new BehaviorSubject<any>([]);
    public loggedInCount = new BehaviorSubject<any>([]);
    public bulkOperationEvent = new BehaviorSubject<any>([]);
    public optimizeRunOperationEvent = new BehaviorSubject<any>({});
    public runPostingOperationEvent = new BehaviorSubject<any>({});
    public identity = new BehaviorSubject<any>({});
    public plannerCardUpdateEvent = new BehaviorSubject<any>({});
    public pendingWorkEvent = new BehaviorSubject<any>({});
    public manifestGeneratedEvent = new BehaviorSubject<any>({});
    public orderExportCompletedEvent = new BehaviorSubject<any>({});
    public refreshRunManifestEvent = new BehaviorSubject<any>({});

    private signedOut = new Subject<void>();

    private readonly db = firebaseDb();

    constructor(private principal: Principal) {
        super();
        this.principal
            .getAuthenticationState()
            .pipe(takeUntil(this._destroyed$))
            .subscribe((userIdentity) => {
                if (userIdentity) {
                    this.identity.next(userIdentity);
                    this.registerFireEvents(userIdentity, 'notification', this.userNotificationEvent);
                    this.registerFireEvents(userIdentity, 'tenantSettings', this.tenantSettingUpdateEvent, true);
                    this.registerFireEvents(userIdentity, 'updateExchangeRate', this.exhangeRateUpdateEvent, true);
                    this.registerFireEvents(userIdentity, 'runStatusChange', this.runStatusChangeEvent, true);
                    this.registerFireEvents(userIdentity, 'loggedInCount', this.loggedInCount, true);
                    this.registerFireEvents(userIdentity, 'bulkOperation', this.bulkOperationEvent, true);
                    this.registerFireEvents(userIdentity, 'optimizeRunOperation', this.optimizeRunOperationEvent, true);
                    this.registerFireEvents(userIdentity, 'runPosting', this.runPostingOperationEvent, true);
                    this.registerFireEvents(userIdentity, 'planner-card-changes', this.plannerCardUpdateEvent, true);
                    this.registerFireEvents(userIdentity, 'manifest-generated', this.manifestGeneratedEvent);
                    this.registerFireEvents(userIdentity, 'refresh-run-manifest', this.refreshRunManifestEvent);
                    this.registerFireEvents(userIdentity, 'order-export-completed', this.orderExportCompletedEvent);
                    this.registerFireEvents(userIdentity, 'pending-work', this.pendingWorkEvent, true);
                } else {
                    this.signedOut.next();
                }
            });
    }

    registerFireEvents(userIdentity: any, eventName: string, subject: BehaviorSubject<any>, isTenantEvent = false) {
        const path =
            environment.firebaseConfig.env + '/events/' + userIdentity.tenantId + (isTenantEvent ? '' : '_' + userIdentity.id) + '/' + eventName;
        onValue(ref(this.db, path), (snapshot) => {
            subject.next(snapshot.val() || {});
        });
    }

    clearFirebaseEvent(eventName: string, isTenantEvent = false) {
        const userIdentity = this.identity.value;
        if (userIdentity) {
            const path =
                environment.firebaseConfig.env + '/events/' + userIdentity.tenantId + (isTenantEvent ? '' : '_' + userIdentity.id) + '/' + eventName;
            set(ref(this.db, path), null);
        }
    }
}
